export const duplicatesCardInfo = {
	title: "Duplicatas",
	subtitle: "Duplicata",
	dueDate: "Vencimento",
	value: "Valor",
};
